
import { defineComponent, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import ServicoCipEstrutura from '@/servicos/Cadastros/PCP/ServicoCipEstrutura';
import CipEstruturaModal from './CipEstruturaModal.vue';

export default defineComponent({
  name: 'CipEstrutura',
  components: {
    TelaPadraoCrud,
    CipEstruturaModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoCipEstrutura = new ServicoCipEstrutura();
    const refCrudCipEstrutura = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.apresentarAcaoExcluirGrade = false;
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Identificador', dataIndex: 'codigo', key: 'Identificador', position: 0, visible: false, ordering: false,
      },
      {
        title: 'Codigo', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: true, ordering: true, fixed: 'left', width: 110, align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Descricao', dataIndex: 'descricao', key: 'Descricao', position: 2, visible: true, ordering: true, fixed: 'left', ellipsis: true, width: 320, align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Tipo Producao', dataIndex: 'codigoTipoProducao', key: 'CodigoTipoProducao', position: 3, visible: true, ordering: true, width: 140, align: 'left',
      },
      {
        title: 'Tipo Periodo', dataIndex: 'tipoPeriodo', key: 'TipoPeriodo', position: 4, visible: true, ordering: true, width: 120, align: 'left',
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'Ativo', position: 5, visible: true, align: 'left', customRenderRow: ECustomRenderRow.TagAtivo, width: 90,
      },
      {
        title: 'Acoes', key: 'acoes', position: 6, visible: true, fixed: 'right', width: 120, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'Codigo', ordem: 'DESC' } as IOrdenacao);

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrudCipEstrutura.value !== undefined) {
        await refCrudCipEstrutura.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }

    return {
      crudBase,
      servicoCipEstrutura,
      refCrudCipEstrutura,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
    };
  },
});
